import { render, staticRenderFns } from "./AddAcademyAdmin.vue?vue&type=template&id=c65e2bce&scoped=true"
import script from "./AddAcademyAdmin.vue?vue&type=script&lang=js"
export * from "./AddAcademyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65e2bce",
  null
  
)

export default component.exports